$("[data-toggle-fade-in]").click(function () {
    $($(this).attr('data-toggle-fade-in')).fadeIn();
});

$("[data-toggle-fade-out]").click(function () {
    $($(this).attr('data-toggle-fade-out')).fadeOut();
});

jQuery.fn.visible = function () {
    return this.css('visibility', 'visible');
};

jQuery.fn.invisible = function () {
    return this.css('visibility', 'hidden');
};

jQuery.fn.hasAttr = function (name) {
    return this.attr(name) !== undefined;
};

jQuery.fn.hasInlineStyle = function (name) {

    //if (this.attr("style").length > 0) {
    //    //do some code
    //}

    var styles = this.attr("style"), value;
    styles && styles.split(";").forEach(function (e) {
        var style = e.split(":");
        if ($.trim(style[0]) === name) {
            value = style[1];
            return true;
        }
    });
    return false;
};
